import axios from "../utils/axios";

export const postReport = async (report) => {
  const { data } = await axios.post("/report", { data: report });
  return data;
};
